import React, { ReactNode } from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { LOCK_SVG } from "../utils/svgs";
import {
  AppCardHeader,
  AppCardHeaderProps,
  AppCardSubtitle,
  AppCardTitle,
} from "./Generic/AppCard";
import { AppIcon } from "./Generic/AppIcon";
import { If } from "./Generic/If";
import { IsDefined } from "./Generic/IsDefined";
interface Props extends AppCardHeaderProps {
  text: string;
  isRequired: boolean;
  notes: string | null;
  isReadonly: boolean;
  recordAction?: ReactNode;
}

const QuestionHeader = (props: Props) => {
  const { text, isRequired, notes, isReadonly, ...rest } = props;

  return (
    <AppCardHeader {...rest} onClick={props.onClick}>
      <AppCardTitle className="flex justify-space-between full-width">
        <div>
          {props.text}
          <If condition={isRequired && !isReadonly}>
            <span className="__badge">{translate(STRINGS.REQUIRED)}</span>
          </If>
        </div>
        <If condition={isReadonly}>
          <AppIcon icon={LOCK_SVG} fill="gray" size={16} />
        </If>
        <If condition={!isReadonly}>{props.recordAction}</If>
      </AppCardTitle>
      <IsDefined value={notes}>
        {(_notes) => <AppCardSubtitle>{`${translate(STRINGS.NOTES)}: ${notes}`}</AppCardSubtitle>}
      </IsDefined>
    </AppCardHeader>
  );
};

export default React.memo(QuestionHeader);
